/*
src/ui-panels/GroundPanel.js
wgbh-skydiagram-testing
astro.unl.edu
2019-06-16
*/


import * as React from 'react';

import {ImagesList} from '../ui-misc/ImagesList.js';


export class GroundPanel extends React.Component {


	constructor(props) {
		super(props);

		// Params are specific properties of the ParamsManager that use the getParams and setParams methods.
		// The paramsOfInterest object is used to fetch only the params used by this panel.
		// The propertiesOfInterest array includes the names of all params of interest, plus any additional
		//	properties of interest that are not params. It is used to determine if the panel needs to be re-rendered.
		// Examples: width is a param, but sunImage is not. Both are properties.
		this._paramsOfInterest = {};
		this._propertiesOfInterest = ['groundImage'];
		for (const key in this._paramsOfInterest) {
			this._propertiesOfInterest.push(key);
		}

		this.forceRender = this.forceRender.bind(this);
		this.paramsManagerChangeCallback = this.paramsManagerChangeCallback.bind(this);
		this.handleSelectImage = this.handleSelectImage.bind(this);
		
		this._paramsMan = this.props.workspace.getParamsManager();
		this._groundImageBank = this.props.workspace.getGroundImageBank();

		this._paramsMan.registerCallback('change', this.paramsManagerChangeCallback);
		this._groundImageBank.registerCallback('change', this.forceRender);

		this.state = {
			dirtyCount: 1,
		};
	}


	forceRender() {
		this.setState(state => ({dirtyCount: state.dirtyCount+1}));
	}

	paramsManagerChangeCallback(type, caller, data) {
		// Re-render only if any of the properties of interest have changed.
		for (const key of this._propertiesOfInterest) {
			if (data.newValues.hasOwnProperty(key)) {
				this.forceRender();
				return;
			}
		}
	}

	handleSelectImage(image) {
		this._paramsMan.setGroundImage(image);
	}


	render() {
		return (
			<div style={{maxWidth: "750px", margin: "30px auto"}}>
		
				<ImagesList bank={this._groundImageBank}
					onSelect={this.handleSelectImage}
					selected={this._paramsMan.getGroundImage()}
				/>
			
			</div>
		);
	}

}


